const API_BASE_URL = process.env.REACT_APP_API_URL || "http://localhost:3001";

class HearAboutService {
  constructor() {
    this.baseURL = `${API_BASE_URL}/api/hearabout`;
  }

  // Get authorization headers
  getHeaders() {
    const token = localStorage.getItem("token");
    return {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    };
  }

  // Get all hear about options
  async getAll() {
    try {
      const response = await fetch(this.baseURL, {
        method: "GET",
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching hear about options:", error);
      throw error;
    }
  }

  // Get a single hear about option by ID
  async getById(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: "GET",
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      return await response.json();
    } catch (error) {
      console.error("Error fetching hear about option:", error);
      throw error;
    }
  }

  // Create a new hear about option
  async create(data) {
    try {
      // Validate input
      if (!data.name || !data.name.trim()) {
        throw new Error("Name is required");
      }

      const response = await fetch(this.baseURL, {
        method: "POST",
        headers: this.getHeaders(),
        body: JSON.stringify({
          name: data.name.trim(),
        }),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Error creating hear about option:", error);
      throw error;
    }
  }

  // Update a hear about option
  async update(id, data) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: "PUT",
        headers: this.getHeaders(),
        body: JSON.stringify(data),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Error updating hear about option:", error);
      throw error;
    }
  }

  // Delete a hear about option
  async delete(id) {
    try {
      const response = await fetch(`${this.baseURL}/${id}`, {
        method: "DELETE",
        headers: this.getHeaders(),
      });

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.error || `HTTP error! status: ${response.status}`
        );
      }

      return await response.json();
    } catch (error) {
      console.error("Error deleting hear about option:", error);
      throw error;
    }
  }
}

export default new HearAboutService();
